import { LANGUAGE_LABELS, LANGUAGES } from "@templestay/i18n";
import type { Language } from "@templestay/i18n";

interface DefaultLanguagePickerProps {
  value: Language;
  onChange: (lang: Language) => void;
  className?: string;
}

export function DefaultLanguagePicker({ value, onChange, className = "" }: DefaultLanguagePickerProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-xs font-medium text-gray-500">기본 언어</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as Language)}
        className="rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 outline-none focus:border-brand-400 focus:ring-1 focus:ring-brand-200"
      >
        {LANGUAGES.map((l) => (
          <option key={l} value={l}>
            {LANGUAGE_LABELS[l]}
          </option>
        ))}
      </select>
      <span className="text-xs text-gray-400">미입력 시 이 언어로 표시</span>
    </div>
  );
}
